function fireDYEvent (props) {

	window.top.DY.API('event', {
		name: 'Add to Cart',
		properties: props
	});

}

function trackAddToCartDy (sku, price, qty) {

	fireDYEvent({
		productId: sku,
		value: price,
		currency: window.utag_data.order_currency_code || 'USD',
		quantity: qty,
		dyType: 'add-to-cart-v1'
	});

}

export default trackAddToCartDy;
